export default __webpack_public_path__ + "static/media/institution-alfred.59eed74d.png";